// extracted by css-extract-rspack-plugin
module.exports =  {"root":"Spinner-m__root___rhCts","icon":"Spinner-m__icon___ub8lf"};